import { post, AHPLUS_API_URL } from 'api/ky';

const IDENTITY_VERIFICATION_URL = `${AHPLUS_API_URL}/api/v2/air_bundle/identity_verifications`;

export const createNewVerificationSession = async (
  journeyId: number,
  airRequestId?: string,
  isAirLuggage?: boolean,
) => {
  const productType = isAirLuggage ? 'air_luggage' : 'air_payout';
  return post(IDENTITY_VERIFICATION_URL, {
    journeyId,
    airRequestId,
    productType,
  });
};

export default { createNewVerificationSession };
